import moment from 'moment';

export const unixNow = (): number => moment().unix();
